import React from 'react';
import { injectIntl } from 'react-intl';

import { getTemplateTypes } from 'helpers/cms';

import FormAutocomplete from 'components/forms/FormAutocomplete';

class CmsTemplateTypes extends React.Component {
  render() {
    const {
      intl: { messages },
      value,
      meta,
      validation,
      onChange,
      disabled,
    } = this.props;

    return (
      <FormAutocomplete
        label={messages.type}
        name="type"
        value={value}
        meta={meta}
        validation={validation}
        onChange={onChange}
        disabled={disabled}
        options={getTemplateTypes(messages)}
      />
    );
  }
}

export default injectIntl(CmsTemplateTypes);
